<template>
    <div>
        <!-- Transferir Baixa -->
        <div class="modal fade" id="transferirBaixaCreditoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="lancamento_credito">
                    <div class="modal-header">
                        <h5 class="modal-title">Pesquisar Lançamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">Identificação de crédito de lançamento, quando esse lançamento não está vinculado a uma fatura.</div>
                        <div class="alert alert-secondary">
                            <div>
                                #{{ lancamento_credito.id_lancamento }}
                                <span class="ml-3" v-if="lancamento_credito.operadora">{{ lancamento_credito.operadora.search }}</span>
                            </div>
                            <div class="small text-muted" v-if="lancamento_credito.descricao">
                                {{ lancamento_credito.st_descricao }}
                            </div>
                            <div>Valor: {{ $util.formatMoeda(lancamento_credito.liquido) }}</div>
                            <div>Uso: {{ $util.formatMoeda(lancamento_credito.uso_credito) }}</div>
                            <div>Saldo: {{ $util.formatMoeda(lancamento_credito.liquido - lancamento_credito.uso_credito) }}</div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    placeholder="Pesquisar..."
                                    v-model="filtro.search" />
                            </div>
                        </div>

                        <table class="table table-hover mt-3">
                            <thead>
                                <tr>
                                    <th width="4%"></th>
                                    <th>Id</th>
                                    <th>Data</th>
                                    <th>Descrição</th>
                                    <th class="text-right">Valor</th>
                                    <th class="text-right">Líquido</th>
                                    <th class="text-right">Uso</th>
                                    <th class="text-right">Retenção</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(lanc, ilx) in lista_lancs" :key="ilx">
                                    <td width="4%">
                                        <input type="checkbox" v-model="lanc.selecionado" />
                                    </td>
                                    <td>#{{ lanc.id_lancamento }}</td>
                                    <td>{{ $util.getFormatDate(lanc.dt_emissao) }}</td>
                                    <td>{{ lanc.st_descricao }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(lanc.dc_valor) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(lanc.liquido) }}</td>
                                    <td class="text-right">
                                        <az-input 
                                            sizing="sm"
                                            placeholder="Uso..."
                                            type="number"
                                            :edicao="!!lanc.selecionado"
                                            v-model="lanc.baixado" />
                                    </td>
                                    <td class="text-right">
                                        <az-input 
                                            sizing="sm"
                                            placeholder="Retenção..."
                                            type="number"
                                            :edicao="!!lanc.selecionado"
                                            v-model="lanc.retencao" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="vincular()">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            dados: null, 
            lancamento_credito: null, 
            filtro: { 
                search: "", 
                id_unidade_operacao: "", 
                id_centro_custo: "", 
                periodo: "do",
                inicio: null,
                fim: null, 
            },
        };
    },

    components: { 
        AzPeriodo, 
        AzInput, 
        AzSubmit, 
    }, 

    computed: { 
        lista_lancs: function () { 
            if ( !this.dados || !this.dados.lista ) { 
                return [];
            }

            return this.dados.lista;
        },

        selecionados: function () { 
            return this.lista_lancs.filter(item => item.selecionado);
        }
    }, 

    methods: { 
        vincular() { 
            if ( !this.selecionados.length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Nenhum lançamento selecionado.',
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: 'financeiro',
                func: 'lancamento_vinculo_credito',
                dados: { 
                    id_lancamento: this.lancamento_credito.id_lancamento, 
                    vinculos: this.selecionados.map(lanc => { 
                        return { 
                            id_lancamento: lanc.id_lancamento, 
                            valor: lanc.baixado, 
                            retencoes: lanc.retencao ? lanc.retencao : 0, 
                        };
                    }), 
                },
                modal: 'transferirBaixaCreditoModal', 
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        abrir(lancamento_credito) { 
            this.dados = null; 
            this.lancamento_credito = _.cloneDeep(lancamento_credito);

            $('#transferirBaixaCreditoModal').modal('show');
        },

        load() { 
            this.$util.load(this, { 
                service: 'financeiro',
                func: 'listar_lancamentos_vinculo_credito',
                parms: { 
                    id_lancamento: this.lancamento_credito.id_lancamento, 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>